import Vue from 'vue'
import * as gtm from '~/utils/gtm-events'
import breadcrumbs from '~/breadcrumbs.json'

export default ({ app }, inject) => {
  if (process.server) return

  // Build the slug → page_type map and the blog-detail slug set from the
  // committed breadcrumbs snapshot so global components report a sensible
  // page_type and blog posts (served at the site root) are detected correctly.
  gtm.setSlugPageTypeMap(gtm.buildSlugPageTypeMap(breadcrumbs))
  gtm.setBlogDetailSlugs(gtm.buildBlogDetailSlugSet(breadcrumbs))

  inject('gtm', gtm)

  let previousUrl = ''
  let lastFiredPath = null

  const firePageEvents = (route, isInitial) => {
    if (!route) return

    const path = route.fullPath || route.path || '/'
    // Dedupe: a single navigation can resolve twice (initial hydration,
    // trailing-slash redirects). Only fire once per resolved path.
    if (path === lastFiredPath) return
    lastFiredPath = path

    // Blog detail pages need blog-style content_groups; they fire their own
    // pushBlogPageDescriptionEvent from mounted(). Skip the generic one here.
    if (!gtm.isBlogDetailSlug(route.path)) {
      gtm.pushPageDescriptionEvent(path)
    }

    Vue.nextTick(() => {
      const referrer = isInitial ? document.referrer || '' : previousUrl
      const currentUrl = window.location.href
      gtm.pushVirtualPageViewEvent(document.title, currentUrl, referrer)
      previousUrl = currentUrl
    })
  }

  // Register afterEach only once the router is ready, so Nuxt's initial route
  // resolution does not double up with the explicit initial fire below.
  app.router.onReady(() => {
    firePageEvents(app.router.currentRoute, true)
    app.router.afterEach((to) => firePageEvents(to, false))
  })
}
